import { SidebarMenuMain } from "./SidebarMenuMain";
import { useStyleContext } from "../../../../helpers/StyleContext";
// import React, { useContext, useEffect, useState } from "react";

const SidebarMenu = () => {
  const { styleState } = useStyleContext();

  return (
    <div
      className="app-sidebar-menu overflow-hidden flex-column-fluid"
      style={{
        backgroundColor: styleState?.sidebar_background_color,
      }}
    >
      <div
        id="kt_app_sidebar_menu_wrapper"
        className="app-sidebar-wrapper hover-scroll-overlay-y my-5"
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-height="auto"
        data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
        data-kt-scroll-wrappers="#kt_app_sidebar_menu"
        data-kt-scroll-offset="5px"
        data-kt-scroll-save-state="true"
      >
        <SidebarMenuMain
          iconColor={styleState?.sidebar_text_color}
          textColor={styleState?.sidebar_text_color}
        />
      </div>
    </div>
  );
};

export { SidebarMenu };
